module.exports = __webpack_public_path__ + "static/feather-sprite-09960c3de0fb9233eaac720d45ab4bc5.svg";